// Initial and live reads are bounded. Older pages are requested only by the
// person opening the conversation; no automatic whole-history traversal.
export async function readConversationHistory({
  storeId,phone,state,older=false,fetcher=fetch,headers={},onPage=()=>{},
}) {
  const base=`/api/crm/conversations/${encodeURIComponent(storeId)}/${encodeURIComponent(phone)}`;
  const mode=older?"older":"recent";
  const query=new URLSearchParams({readMode:"memory-v1",mode});
  if(older)query.set("cursors",JSON.stringify(state?.older||{}));
  const response=await fetcher(`${base}?${query}`,{
    credentials:"same-origin",cache:"no-store",headers:{Accept:"application/json",...headers},
  });
  if(!response.ok)throw Object.assign(Error(`histórico individual indisponível (${response.status})`),{status:response.status});
  const payload=await response.json();
  if(Number(payload.storeId)!==Number(storeId)||String(payload.phone)!==String(phone)) {
    throw Error("histórico individual retornou uma identidade diferente");
  }
  const ids=Object.keys(payload.messages||{});
  const overlaps=state?.recentIds?.some(id=>ids.includes(id));
  onPage(payload);
  return {payload,pages:1,state:{
    older:older?payload.next:overlaps?state.older:payload.next,
    recentIds:older?(state?.recentIds||ids):ids,
    complete:!Object.values(older?payload.next:overlaps?state.older||{}:payload.next||{}).some(v=>v!==false),
    watermark:payload.watermark||new Date().toISOString(),
  }};
}
